import React from "react";
import { withRouter } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { LinkContainer } from "react-router-bootstrap";
import { Chip } from "@material-ui/core";

class Orders extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props;
  }
  render() {
    const { orders, deliveries } = this.props;
    return (
      <div className="container-fluid">
        <Accordion>
          {Boolean(deliveries.length) || Boolean(orders.length) || (
            <div className="pl-5">
              <h5> Nothing got cancelled </h5>
            </div>
          )}
          {deliveries.map((order, i) => (
            <Card key={i}>
              <Accordion.Toggle
                as={Button}
                variant={
                  deliveries[i].pickup ? "outline-secondary" : "outline-info"
                }
                eventKey={`${deliveries[i].id}`}
              >
                {deliveries[i].name}: {deliveries[i].order_number} to{" "}
                {deliveries[i].shipto_first_name}{" "}
                {deliveries[i].shipto_last_name}
                {deliveries[i].fulfillment_status == "partial" && (
                  <Chip
                    label={deliveries[i].fulfillment_status}
                    color="secondary"
                  />
                )}
              </Accordion.Toggle>
              <Accordion.Collapse eventKey={`${deliveries[i].id}`}>
                <Card.Body className="mb-2">
                  <span className="font-weight-bold">Destination:</span>{" "}
                  {deliveries[i].shipto_address1}{" "}
                  {deliveries[i].shipto_address2}, {deliveries[i].shipto_city},{" "}
                  {deliveries[i].shipto_zip}
                  <br></br>
                  <span className="font-weight-bold">Contact:</span>{" "}
                  {deliveries[i].shipto_phone || deliveries[i].shipto_email}{" "}
                  <br></br>
                  <span className="font-weight-bold">Created at:</span>{" "}
                  {moment(deliveries[i].created_at).format(
                    "MMMM Do YYYY, h:mm:ss a"
                  )}{" "}
                  <br></br>
                  <span className="font-weight-bold">Scheduled: </span>{" "}
                  {deliveries[i].date} between {deliveries[i].delivery_window}{" "}
                  <br></br>
                  <span className="font-weight-bold">Cancelled At:</span>{" "}
                  {moment(deliveries[i].cancelled_at).format(
                    "MMMM Do YYYY, h:mm:ss a"
                  )}{" "}
                  <br></br>
                  <span className="font-weight-bold">Cancelled By:</span>{" "}
                  {deliveries[i].cancelled_by} <br></br>
                  <LinkContainer to={`/fulfillments/${deliveries[i].order_id}`}>
                    <Button className="mr-5" variant="success">
                      Show Order
                    </Button>
                  </LinkContainer>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          ))}
          {orders.map((order, i) => {
            const variant = i % 2 == 0 ? "info" : "secondary";
            return (
              <Card key={i}>
                <Accordion.Toggle
                  as={Button}
                  variant={
                    orders[i].pickup ? "outline-secondary" : "outline-info"
                  }
                  eventKey={`${orders[i].id}`}
                >
                  {orders[i].name}: {orders[i].order_number} to{" "}
                  {orders[i].shipto_first_name} {orders[i].shipto_last_name}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={`${orders[i].id}`}>
                  <Card.Body className="mb-2">
                    <span className="font-weight-bold">Destination:</span>{" "}
                    {orders[i].shipto_address1} {orders[i].shipto_address2},{" "}
                    {orders[i].shipto_city}, {orders[i].shipto_zip}
                    <br></br>
                    <span className="font-weight-bold">Contact:</span>{" "}
                    {orders[i].shipto_phone || orders[i].shipto_email} <br></br>
                    <span className="font-weight-bold">Created at:</span>{" "}
                    {moment(orders[i].created_at).format(
                      "MMMM Do YYYY, h:mm:ss a"
                    )}{" "}
                    <br></br>
                    <span className="font-weight-bold">Scheduled: </span>{" "}
                    {orders[i].date} between {orders[i].delivery_window}{" "}
                    <br></br>
                    <span className="font-weight-bold">Cancelled At:</span>{" "}
                    {moment(orders[i].cancelled_at).format(
                      "MMMM Do YYYY, h:mm:ss a"
                    )}{" "}
                    <span className="font-weight-bold">Cancelled By:</span>{" "}
                    {orders[i].cancelled_by} <br></br>
                    <LinkContainer to={`/fulfillments/${orders[i].order_id}`}>
                      <Button className="mr-5" variant="success">
                        Show Order
                      </Button>
                    </LinkContainer>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            );
          })}
        </Accordion>
      </div>
    );
  }
}

export default withRouter(Orders);
